module.exports = __webpack_public_path__ + "img/案例3.726159b4.png";